import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/district'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(district) {
    return http.post(`${resource}`, district)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(district, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, district)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
